import { render, staticRenderFns } from "./NavbarMetadata.vue?vue&type=template&id=f13a87f4&scoped=true"
import script from "./NavbarMetadata.vue?vue&type=script&lang=js"
export * from "./NavbarMetadata.vue?vue&type=script&lang=js"
import style0 from "./NavbarMetadata.vue?vue&type=style&index=0&id=f13a87f4&prod&lang=scss&scoped=true"
import style1 from "./NavbarMetadata.vue?vue&type=style&index=1&id=f13a87f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13a87f4",
  null
  
)

export default component.exports